import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useMemo, type ReactNode } from 'react';

interface StyleProviderProps {
  children: ReactNode;
  /** Optional nonce value for CSP (Content Security Policy) */
  nonce?: string;
}

/**
 * Provides Emotion CSS-in-JS styling context for Insforge components.
 *
 * This ensures styles are injected dynamically at runtime, preventing FOUC
 * in SSR environments like Next.js.
 *
 * @internal
 */
export function StyleProvider({ children, nonce }: StyleProviderProps) {
  const cache = useMemo(() => {
    const emotionCache = createCache({
      key: 'if-styles',
      prepend: true,
      nonce,
    });

    return emotionCache;
  }, [nonce]);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
